<template>
  <div class="bar" :class="{ 'app-bar': isApp }" v-if="isApp">
    <div class="close iconfont icon-cha" @click.stop="bindBack"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isApp: false
    }
  },
  created() {
    this.isApp = this.$http._isApp()
  },
  methods: {
    bindBack() {
      this.$http.appBack()
    }
  }
}
</script>
<style lang="scss" scoped>
.bar {
  .close {
    padding: 10px;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 600;
    position: absolute;
    left: 24px;
    top: 45px;
    z-index: 99;
  }
}
.app-bar {
  height: 80px;
}
</style>
